/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.token)?_c('iframe',{staticStyle:{"width":"0","height":"0","border":"0","position":"absolute"},attrs:{"src":_vm.iframeSrc}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }